import { gql } from '@apollo/client';

export const AscProjectTpTicketsViewFragment = gql`
  fragment AscProjectTpTicketsView on AscProjectTpTicketsView {
    id
    ascProjectId
    contributorId
    contributorName
    identifier
    ticketUrl
    name
    completedDatetime
    predictedEffortDays
    groupingTicketingProviderTicketId
    groupingTicketingProviderCollectionId
    matchingConfidence
    matchingReasoning
    matchingMethod
  }
`;
